import { observer } from 'mobx-react';
import { UserProductLicenseResource } from '../../../../../ParticipantsStore/Types';
import { T } from '../../../../../Translations';
import { emptyFragment } from '../../../../../EmptyFragment';

interface Props {
  license: UserProductLicenseResource;
}

function AuditorStatus({ license }: Props) {
  switch (license.payload.registrationType) {
    case 'auditor':
      return (
        <span className="bg-gray-400 text-xs rounded text-white py-1 px-2">
          <T kind="Auditor" />
        </span>
      );
    case 'student':
      return emptyFragment();
  }
}

export default observer(AuditorStatus);
